// extracted by mini-css-extract-plugin
export default {"header":"Header_header__wVzTX","logo":"Header_logo__8j8+1","title":"Header_title__kaNJC","info":"Header_info__V1KUB"};